var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2760",
    d: "M0-682.665H20v20H0Z",
    transform: "translate(0 682.665)",
    fill: "#333"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2754",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2756",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2758",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2764",
    transform: "translate(0.586 0.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2766",
    d: "M-232.968,0A7.031,7.031,0,0,0-240,7.031a7,7,0,0,0,1.974,4.878L-240,14.062h7.031a7.031,7.031,0,0,0,7.031-7.031A7.031,7.031,0,0,0-232.968,0Z",
    transform: "translate(239.999)",
    fill: "none",
    stroke: "#8dc63f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2768",
    transform: "translate(8.515 8.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2770",
    d: "M0-201.347a5.469,5.469,0,0,0,5.431,4.822H10.9L9.364-198.2a5.446,5.446,0,0,0,1.535-3.794,5.469,5.469,0,0,0-4.822-5.431",
    transform: "translate(0 207.423)",
    fill: "none",
    stroke: "#8dc63f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2772",
    transform: "translate(3.711 4.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2774",
    d: "M-194.14,0a2.027,2.027,0,0,0-1.953,1.465h0A2.027,2.027,0,0,0-198.046,0,1.953,1.953,0,0,0-200,1.953c0,2.441,3.906,4.883,3.906,4.883s3.906-2.441,3.906-4.883A1.953,1.953,0,0,0-194.14,0Z",
    transform: "translate(200)",
    fill: "#ff1b36"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.7737548a9d4c50e8c74871359964f62f.svg";
export { ForwardRef as ReactComponent };